import TabsCode from "!!raw-loader!./tabs/Tabs.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Tabs from "./tabs/Tabs";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Tabs", TabsCode, Tabs),
	];

	return (
		<Pane
			components={components}
			imports={"import {Tabs} from \"designSystem/index\";"}
			muiApi="tabs"
			muiComponent="tabs"
			{...props}
		/>
	);
};